var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalculator = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7.5 7 15 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.5 14h11V9h-11zm9 3h2v-1h-2zm0 2h2v-1h-2zm-3-2h2v-1h-2zm0 2h2v-1h-2zm0 2h5v-1h-5zm-3-4h2v-1h-2zm0 2h2v-1h-2zm0 2h2v-1h-2zm-3-4h2v-1h-2zm0 2h2v-1h-2zm0 2h2v-1h-2zm12-14h-13a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1"
})));
export default SvgCalculator;